<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb
            name="Update Details"
            bc1="App"
            bc2="Currency Payment"
            bc3="Update"
            path="currency-payment-method"
          ></Breadcrumb>
        </div>
      </div>
      <div class="content-body">
        <!-- Basic Horizontal form layout section start -->
        <section id="basic-horizontal-layouts">
          <div class="row">
            <div class="col-md-12 col-12">
              <div class="card">
                <div class="card-header">
                  <h4 class="card-title">Update Details</h4>
                </div>
                <div class="card-body">
                  <ValidationObserver
                    ref="observer"
                    tag="form"
                    v-slot="{ invalid, validate }"
                  >
                    <form
                      class="form form-horizontal"
                      @submit.prevent="validate().then(sendCall)"
                    >
                      <div>
                        <div>
                          <div
                            class="col-sm-9 offset-sm-3 text-right mt-2"
                          ></div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12">
                          <div class="form-group row">
                            <div class="col-sm-3 col-form-label">
                              <label>Payment Method </label>
                            </div>
                            <div class="col-sm-9">
                              <div class="input-group">
                                <b-form-select
                                  v-model="paymentId"
                                  size="sm"
                                  class="mt-1"
                                  @change="
                                    paymentCodeChange(
                                      paymentMethodRequestData,
                                      paymentId
                                    )
                                  "
                                >
                                  <b-form-select-option
                                    :value="item.id"
                                    v-for="(item, index) in paymentMethodRequestData"
                                    :key="index"
                                    >{{ item.name }}
                                  </b-form-select-option>
                                </b-form-select>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-12">
                          <div class="form-group row">
                            <div class="col-sm-3 col-form-label">
                              <label>Currency</label>
                            </div>
                            <div class="col-sm-9">
                              <div class="input-group">
                                <b-form-select
                                  v-model="currencyId"
                                  :value="currencyId"
                                  size="sm"
                                  class="mt-1"
                                >
                                  <b-form-select-option
                                    v-for="(item, index) in currencyRequestData"
                                    :key="index"
                                    :value="item.id"
                                    :selected="item.code"
                                    >{{ item.name }}
                                  </b-form-select-option>
                                </b-form-select>
                              </div>
                            </div>
                          </div>
                        </div>
<!--                        <div-->
<!--                          class="col-12"-->
<!--                          v-if="code == '0001' || code == '0002'"-->
<!--                        >-->
<!--                          <div class="form-group row">-->
<!--                            <div class="col-sm-3 col-form-label">-->
<!--                              <label for="name-icon">Bypass3DS</label>-->
<!--                            </div>-->
<!--                            <div class="col-sm-9">-->
<!--                              <input-->
<!--                                class="custom-checkbox"-->
<!--                                type="checkbox"-->
<!--                                v-model="byPass3DS"-->
<!--                                name="bypass3dcheckbox"-->
<!--                              />-->
<!--                            </div>-->
<!--                          </div>-->
<!--                        </div>-->
                        <div class="col-12" v-if="code == '0002'">
                          <div class="form-group row">
                            <div class="col-sm-3 col-form-label">
                              <label for="symbol-icon">Settings</label>
                            </div>
                            <div class="col-12">
                              <div class="added-field">
                                <div class="col-12">
                                  <div class="form-group row">
                                    <div
                                        class="col-sm-3 col-form-label text-right"
                                    >
                                      <label for="name-icon">Bypass3DS</label>
                                    </div>
                                    <div class="col-sm-9">
                                      <div class="">
                                        <input
                                            class="custom-checkbox form-control "
                                            style="margin-top: 0.7rem;"
                                            type="checkbox"
                                            v-model="byPass3DS"
                                            name="bypass3dcheckbox"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-12">
                                  <ValidationProvider
                                    name="username"
                                    ref="username"
                                    rules="required"
                                    v-slot="{ errors }"
                                  >
                                    <div class="form-group row">
                                      <div
                                        class="col-sm-3 col-form-label text-right"
                                      >
                                        <label for="name-icon">Username</label>
                                      </div>
                                      <div class="col-sm-9">
                                        <div class="input-group">
                                          <input
                                            type="text"
                                            v-model="settings2.username"
                                            class="form-control"
                                            name="username"
                                            :class="
                                              errors[0] ? 'is-invalid' : ''
                                            "
                                            v-validate="'required'"
                                            placeholder="Username"
                                          />
                                        </div>
                                        <small
                                          class="block text-red-600 text-xs absolute bottom-0 left-0"
                                          style="color:#EA5455"
                                          >{{ errors[0] }}</small
                                        >
                                      </div>
                                    </div>
                                  </ValidationProvider>
                                </div>

                                <div class="col-12">
                                  <ValidationProvider
                                    name="password"
                                    ref="password"
                                    rules="required"
                                    v-slot="{ errors }"
                                  >
                                    <div class="form-group row">
                                      <div
                                        class="col-sm-3 col-form-label text-right"
                                      >
                                        <label for="name-icon">Password</label>
                                      </div>
                                      <div class="col-sm-9">
                                        <div class="input-group">
                                          <input
                                            type="text"
                                            v-model="settings2.password"
                                            class="form-control"
                                            v-validate="'required'"
                                            placeholder="Password"
                                            :class="
                                              errors[0] ? 'is-invalid' : ''
                                            "
                                            name="password"
                                          />
                                        </div>
                                        <small
                                          class="block text-red-600 text-xs absolute bottom-0 left-0"
                                          style="color:#EA5455"
                                          >{{ errors[0] }}</small
                                        >
                                      </div>
                                    </div>
                                  </ValidationProvider>
                                </div>

                                <div class="col-12">
                                  <ValidationProvider
                                    name="customerName"
                                    ref="customerName"
                                    rules="required"
                                    v-slot="{ errors }"
                                  >
                                    <div class="form-group row">
                                      <div
                                        class="col-sm-3 col-form-label text-right"
                                      >
                                        <label for="name-icon"
                                          >Customer Name</label
                                        >
                                      </div>
                                      <div class="col-sm-9">
                                        <div class="input-group">
                                          <input
                                            type="text"
                                            :class="
                                              errors[0] ? 'is-invalid' : ''
                                            "
                                            v-model="settings2.customerName"
                                            class="form-control"
                                            v-validate="'required'"
                                            placeholder="Customer Name"
                                            name="customerName"
                                          />
                                        </div>
                                        <small
                                          class="block text-red-600 text-xs absolute bottom-0 left-0"
                                          style="color:#EA5455"
                                          >{{ errors[0] }}</small
                                        >
                                      </div>
                                    </div>
                                  </ValidationProvider>
                                </div>
                                <div class="col-12">
                                  <div class="form-group row">
                                    <div
                                      class="col-sm-3 col-form-label text-right"
                                    >
                                      <label for="name-icon"
                                        >Transaction Hint</label
                                      >
                                    </div>
                                    <div class="col-sm-9">
                                      <ValidationProvider
                                        name="transactionHint"
                                        ref="transactionHint"
                                        rules="required"
                                        v-slot="{ errors }"
                                      >
                                        <div class="input-group">
                                          <input
                                            type="text"
                                            v-model="settings2.transactionHint"
                                            class="form-control"
                                            v-validate="'required'"
                                            placeholder="Transaction Hint"
                                            :class="
                                              errors[0] ? 'is-invalid' : ''
                                            "
                                            name="url"
                                          />
                                        </div>
                                        <small
                                          class="block text-red-600 text-xs absolute bottom-0 left-0"
                                          style="color:#EA5455"
                                          >{{ errors[0] }}</small
                                        >
                                      </ValidationProvider>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-12">
                                  <div class="form-group row">
                                    <div
                                      class="col-sm-3 col-form-label text-right"
                                    >
                                      <label for="name-icon"
                                        >Channel</label
                                      >
                                    </div>
                                    <div class="col-sm-9">
                                      <ValidationProvider
                                        name="channel"
                                        ref="channel"
                                        rules="required"
                                        v-slot="{ errors }"
                                      >
                                        <div class="input-group">
                                          <input
                                            type="text"
                                            v-model="settings2.channel"
                                            class="form-control"
                                            v-validate="'required'"
                                            placeholder="channel"
                                            :class="
                                              errors[0] ? 'is-invalid' : ''
                                            "
                                            name="channel"
                                          />
                                        </div>
                                        <small
                                          class="block text-red-600 text-xs absolute bottom-0 left-0"
                                          style="color:#EA5455"
                                          >{{ errors[0] }}</small
                                        >
                                      </ValidationProvider>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-12">
                                  <div class="form-group row">
                                    <div
                                      class="col-sm-3 col-form-label text-right"
                                    >
                                      <label for="name-icon"
                                        >Store</label
                                      >
                                    </div>
                                    <div class="col-sm-9">
                                      <ValidationProvider
                                        name="store"
                                        ref="store"
                                        rules="required"
                                        v-slot="{ errors }"
                                      >
                                        <div class="input-group">
                                          <input
                                            type="text"
                                            v-model="settings2.store"
                                            class="form-control"
                                            v-validate="'required'"
                                            placeholder="store"
                                            :class="
                                              errors[0] ? 'is-invalid' : ''
                                            "
                                            name="store"
                                          />
                                        </div>
                                        <small
                                          class="block text-red-600 text-xs absolute bottom-0 left-0"
                                          style="color:#EA5455"
                                          >{{ errors[0] }}</small
                                        >
                                      </ValidationProvider>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-12">
                                  <div class="form-group row">
                                    <div
                                      class="col-sm-3 col-form-label text-right"
                                    >
                                      <label for="name-icon"
                                        >Terminal</label
                                      >
                                    </div>
                                    <div class="col-sm-9">
                                      <ValidationProvider
                                        name="terminal"
                                        ref="terminal"
                                        rules="required"
                                        v-slot="{ errors }"
                                      >
                                        <div class="input-group">
                                          <input
                                            type="text"
                                            v-model="settings2.terminal"
                                            class="form-control"
                                            v-validate="'required'"
                                            placeholder="terminal"
                                            :class="
                                              errors[0] ? 'is-invalid' : ''
                                            "
                                            name="terminal"
                                          />
                                        </div>
                                        <small
                                          class="block text-red-600 text-xs absolute bottom-0 left-0"
                                          style="color:#EA5455"
                                          >{{ errors[0] }}</small
                                        >
                                      </ValidationProvider>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-12" v-if="code == '0001'">
                          <div class="form-group row">
                            <div class="col-sm-3 col-form-label">
                              <label for="symbol-icon">Settings</label>
                            </div>
                            <div class="col-12">
                              <div class="added-field">
                                <div class="col-12">
                                  <div class="form-group row">
                                    <div
                                        class="col-sm-3 col-form-label text-right"
                                    >
                                      <label for="name-icon">Bypass3DS</label>
                                    </div>
                                    <div class="col-sm-9">
                                      <div class="">
                                        <input
                                            class="custom-checkbox form-control "
                                            style="margin-top: 0.7rem;"
                                            type="checkbox"
                                            v-model="byPass3DS"
                                            name="bypass3dcheckbox"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-12">
                                  <div class="form-group row">
                                    <div
                                      class="col-sm-3 col-form-label text-right"
                                    >
                                      <label for="name-icon"
                                        >Authorization</label
                                      >
                                    </div>
                                    <div class="col-sm-9">
                                      <ValidationProvider
                                        name="Authorization"
                                        ref="Authorization"
                                        rules="required"
                                        v-slot="{ errors }"
                                      >
                                        <div class="input-group">
                                          <input
                                            type="text"
                                            v-model="settings1.Authorization"
                                            class="form-control"
                                            :class="
                                              errors[0] ? 'is-invalid' : ''
                                            "
                                            v-validate="'required'"
                                            placeholder="Authorization"
                                            name="Authorization"
                                          />
                                        </div>
                                        <small
                                          class="block text-red-600 text-xs absolute bottom-0 left-0"
                                          style="color:#EA5455"
                                          >{{ errors[0] }}</small
                                        >
                                      </ValidationProvider>
                                    </div>
                                  </div>
                                </div>

<!--                                <div class="col-12">-->
<!--                                  <ValidationProvider-->
<!--                                    name="url"-->
<!--                                    ref="url"-->
<!--                                    rules="required"-->
<!--                                    v-slot="{ errors }"-->
<!--                                  >-->
<!--                                    <div class="form-group row">-->
<!--                                      <div-->
<!--                                        class="col-sm-3 col-form-label text-right"-->
<!--                                      >-->
<!--                                        <label for="name-icon">URL</label>-->
<!--                                      </div>-->
<!--                                      <div class="col-sm-9">-->
<!--                                        <div class="input-group">-->
<!--                                          <input-->
<!--                                            type="text"-->
<!--                                            v-model="settings1.url"-->
<!--                                            class="form-control"-->
<!--                                            v-validate="'required'"-->
<!--                                            placeholder="URL"-->
<!--                                            :class="-->
<!--                                              errors[0] ? 'is-invalid' : ''-->
<!--                                            "-->
<!--                                            name="url"-->
<!--                                          />-->
<!--                                        </div>-->
<!--                                        <small-->
<!--                                          class="block text-red-600 text-xs absolute bottom-0 left-0"-->
<!--                                          style="color:#EA5455"-->
<!--                                          >{{ errors[0] }}</small-->
<!--                                        >-->
<!--                                      </div>-->
<!--                                    </div>-->
<!--                                  </ValidationProvider>-->
<!--                                </div>-->
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-12 off-sm-3 text-right mt-2 d-flex">
                        <button
                          type="submit"
                          class="btn btn-primary mr-1 d-flex"
                          :disabled="loading"
                        >
                          <Loader :loading="loading" :size="size"></Loader>
                          Submit
                        </button>
                        <button
                          type="button"
                          class="btn btn-gradient-secondary"
                          @click="
                            $router.push({ name: 'currency-payment-method' })
                          "
                        >
                          Back
                        </button>
                      </div>
                    </form>
                  </ValidationObserver>
                </div>
              </div>
            </div>
          </div>
        </section>
        <!-- Basic Horizontal form layout section end -->
      </div>
    </div>
  </div>
  <!-- END: Content-->
</template>

<script>
import { CommandIcon } from "vue-feather-icons";
import { mapGetters } from "vuex";
import { ValidationObserver, ValidationProvider } from "vee-validate";

export default {
  components: {
    CommandIcon,
    ValidationObserver,
    ValidationProvider
  },
  data() {
    return {
      paymentMethodRequestData: [],
      currencyRequestData: [],
      byPass3DS: "",
      description: "",
      paymentId: "",
      currencyId: "",
      dataFields: [],
      data: [],
      code: "",
      settings1: {
        Authorization: "",
        url: ""
      },
      settings2: {
        username: "",
        password: "",
        customerName: "",
        transactionHint: "",
        channel:"",
        store:"",
        terminal:"",
      },
      settingsData: [],
      id: "",
      index: "",
      paymentUpdateData: [],
      paymentMethodDefaultID: "",
      loading: false,
      size: "10px"
    };
  },

  created() {
    this.makeRequest("post", "v1/get-payment-method", { flag: "active" },{},false).then(
      callResponse => {
        if (!callResponse.error) {
          let code = callResponse.response.data.code;
          // let data = callResponse.response.data.data;
          // data.key = "paymentMethodSelect";
          if (code == 200) {
            let data = [];
            data = callResponse.response.data.data;
            this.paymentMethodRequestData = data
            // this.$store.dispatch("set", data);
          }
        }
      }
    );
    this.makeRequest("post", "v1/get-currency", { flag: "active" },{},false).then(
      callResponse => {
        if (!callResponse.error) {
          let code = callResponse.response.data.code;
          // let data = callResponse.response.data.data;
          // data.key = "currencySelect";
          if (code == 200) {
            let data = [];
            data = callResponse.response.data.data;
            this.currencyRequestData = data
            // this.$store.dispatch("set", data);
          }
        }
      }
    );
  },
  computed: {
    ...mapGetters({
      CurrencyPaymentData: "getByKey"
    })
  },
  mounted() {
    var paymentUpdateData = this.$store.getters.getByKey(
      "currencyPaymentUpdate"
    );
    this.index = paymentUpdateData.index;
    this.id = paymentUpdateData.row.id;
    this.paymentUpdateData = paymentUpdateData;
    this.currencyId = paymentUpdateData.row.currency_id;
    this.paymentId = paymentUpdateData.row.payment_method_id;
    this.code = paymentUpdateData.row.payment_method.code;
    this.paymentMethodDefaultID = paymentUpdateData.row.payment_method_id;
    if (typeof paymentUpdateData.row.data == "object") {
      if (this.code == "0001") {
        this.byPass3DS = paymentUpdateData.row.data.Bypass3DS;
        this.settings1.Authorization = paymentUpdateData.row.data.Authorization;
        // this.settings1.url = paymentUpdateData.row.data.url;
      } else if (this.code == "0002") {
        this.byPass3DS = paymentUpdateData.row.data.Bypass3DS;
        this.settings2.username = paymentUpdateData.row.data.UserName;
        this.settings2.password = paymentUpdateData.row.data.Password;
        this.settings2.customerName = paymentUpdateData.row.data.Customer;
        this.settings2.transactionHint = paymentUpdateData.row.data.TransactionHint;
        this.settings2.channel = paymentUpdateData.row.data.Channel;
        this.settings2.store = paymentUpdateData.row.data.Store;
        this.settings2.terminal = paymentUpdateData.row.data.Terminal;
      }
    } else if (
      typeof paymentUpdateData.row.data == "string" &&
      paymentUpdateData.row.data
    ) {
      let data = [];
      data.push(JSON.parse(paymentUpdateData.row.data));
      if (this.code == "0001") {
        this.byPass3DS = data[0][0].Bypass3DS;
        this.settings1.Authorization = data[0][0].Authorization;
        // this.settings1.url = data[0][0].url;
      } else if (this.code == "0002") {
        this.byPass3DS = data[0][0].Bypass3DS;
        this.settings2.username = data[0][0].UserName;
        this.settings2.password = data[0][0].Customer;
        this.settings2.customerName = data[0][0].Password;
        this.settings2.transactionHint = data[0][0].TransactionHint;
        this.settings2.channel = data[0][0].Channel;
        this.settings2.store = data[0][0].Store;
        this.settings2.terminal = data[0][0].Terminal;
      }
    }
  },
  methods: {
    paymentCodeChange(data, id) {
      this.$validator.pause();
      const payment = data.find(item => item.id === id);
      this.code = payment.code;
      if (payment.id === this.paymentMethodDefaultID) {
        let data = this.paymentUpdateData;
        let code = this.paymentUpdateData.row.payment_method.code;
        if (code == "0001") {
          this.byPass3DS = data.row.data.Bypass3DS;
          this.settings1.Authorization = data.row.data.Authorization;
          // this.settings1.url = data.row.data.url;
        } else if (code == "0002") {
          this.byPass3DS = data.row.data.Bypass3DS;
          this.settings2.username = data.row.data.UserName;
          this.settings2.password = data.row.data.Customer;
          this.settings2.customerName = data.row.data.Password;
          this.settings2.transactionHint = data.row.data.TransactionHint;
          this.settings2.channel = data.row.data.Channel;
          this.settings2.store = data.row.data.Store;
          this.settings2.terminal = data.row.data.Terminal;
        }
        let paymentData = this.paymentUpdateData;
        if (typeof paymentData.row.data == "string" && paymentData.row.data) {
          let data = [];
          data.push(JSON.parse(paymentData.row.data));
          if (this.code == "0001") {
            this.byPass3DS = data[0][0].Bypass3DS;
            this.settings1.Authorization = data[0][0].Authorization;
            // this.settings1.url = data[0][0].url;
          } else if (this.code == "0002") {
            this.byPass3DS = data[0][0].Bypass3DS;
            this.settings2.username = data[0][0].UserName;
            this.settings2.password = data[0][0].Customer;
            this.settings2.customerName = data[0][0].Password;
            this.settings2.transactionHint = data[0][0].TransactionHint;
          }
        }
      } else {
        this.settings1.Authorization = "";
        // this.settings1.url = "";
        this.settings2.username = "";
        this.settings2.password = "";
        this.settings2.customerName = "";
        this.settings2.transactionHint = "";
        this.settings2.channel = "";
        this.settings2.store = "";
        this.settings2.terminal = "";
      }
    },
    sendCall() {
      this.$validator.validateAll().then(valid => {
        if (valid) {
          this.loading = true;
          if (this.code == "0002") {
            // this.settingsData.push({
            //   Bypass3DS: this.byPass3DS,
            //   UserName: this.settings2.username,
            //   Password: this.settings2.password,
            //   Customer: this.settings2.customerName,
            //   TransactionHint: this.settings2.transactionHint
            // });
            this.settingsData = {
              Bypass3DS: this.byPass3DS,
              UserName: this.settings2.username,
              Password: this.settings2.password,
              Customer: this.settings2.customerName,
              TransactionHint: this.settings2.transactionHint,
              Channel: this.settings2.channel,
              Store: this.settings2.store,
              Terminal: this.settings2.terminal
            }
          } else if (this.code == "0001") {
            // this.settingsData.push({
            //   Bypass3DS: this.byPass3DS,
            //   Authorization: this.settings1.Authorization,
            //   url: this.settings1.url
            // });
            this.settingsData ={
              Bypass3DS: this.byPass3DS,
              Authorization: this.settings1.Authorization,
              // url: this.settings1.url
            }
          }
          // let data = new FormData();
          // data.append("application", "android");
          // data.append("applicationVersion", "1.33");
          // data.append("deviceId", "XXXXXXXXXXXXXXXXXXXXXXXX");
          // data.append("deviceDetail", "android s4 etc");
          // data.append("latitude", "");
          // data.append("longitude", "");
          // data.append("id", this.id);
          // data.append("currencyId", this.currencyId);
          // data.append("paymentMethodId", this.paymentId);
          // data.append("data", JSON.stringify(this.settingsData));

          let requestData = {
            id : this.id,
            currencyId : this.currencyId,
            paymentMethodId : this.paymentId,
            data: JSON.stringify(this.settingsData)
          }

          this.makeRequest(
            "post",
            "v1/update-currency-payment-method",
              requestData
          ).then(callResponse => {
            if (!callResponse.error) {
              let code = callResponse.response.data.code;
              if (code == 200) {
                this.loading = false;
                if (callResponse.response.data.data) {
                  let responseData = callResponse.response.data.data;
                  let storeData = this.$store.getters.getByKey(
                    "currencyPayment"
                  );
                  if (storeData != null) {
                    if (typeof storeData.firstPageData != "undefined") {
                      if (
                        typeof storeData.firstPageData.data[this.index] !=
                        "undefined"
                      ) {
                        if (
                          storeData.firstPageData.data[this.index].id == this.id
                        ) {
                          storeData.firstPageData.data[
                            this.index
                          ] = responseData;
                          delete storeData.otherPageData;
                        }
                      }
                    }
                    if (typeof storeData.otherPageData != "undefined") {
                      if (
                        typeof storeData.otherPageData.data[this.index] !=
                        "undefined"
                      ) {
                        if (
                          storeData.otherPageData.data[this.index].id == this.id
                        ) {
                          storeData.otherPageData.data[
                            this.index
                          ] = responseData;
                        }
                      }
                    }
                    storeData.key = "currencyPayment";
                    this.$store.dispatch("set", storeData);
                  }
                  this.$router.push({
                    name: "currency-payment-method",
                    params: { update: true }
                  });
                }
              } else {
                this.loading = false;
              }
            }
          });
        }
      });
    }
  }
};
</script>

